import { Injectable } from '@angular/core';
import { TrackingRegistryService } from 'src/generated-sources/openapi/wallet-service/tracking-registry';
import { map, Observable } from 'rxjs';
import { PageLoaderService } from 'src/app/services/page-loader.service';
import {
  TrackingRegistryBaseFacade,
  TrackingRegistryViewBase,
  RestrictiveData,
} from 'src/app/shared/services/tracking-registry-base.facade';

export type { RestrictiveData };
export interface RegistryFavoriteView extends TrackingRegistryViewBase {}

@Injectable({
  providedIn: 'root',
})
export class RegistryFavoriteFacade extends TrackingRegistryBaseFacade {
  constructor(
    trackingRegistryService: TrackingRegistryService,
    pageLoaderService: PageLoaderService
  ) {
    super(trackingRegistryService, pageLoaderService);
  }

  public listFavorites(
    page: number,
    perPage: number
  ): Observable<{ items: RegistryFavoriteView[]; total: number }> {
    return this.trackingRegistryService
      .listPageable({ page, perPage, favorite: true })
      .pipe(
        map((response) => ({
          items: response.items.map((dto) => this.transformToView(dto)),
          total: response.total,
        }))
      );
  }
}
